import { CMS_PLUGIN_ID } from '@wix/wix-data-schema-types';
const getAutoCMSSort = (schema) => schema?.plugins?.[CMS_PLUGIN_ID]?.siteSort?.sort;
const getSortFromSchema = (schema) => (getAutoCMSSort(schema) || []).map(({ fieldName, direction }) => ({
    [fieldName]: direction,
}));
export const isSortMirroringEnabled = (schema) => !!getAutoCMSSort(schema);
export const getSort = async ({ datasetConfigSort, getSchema, }) => {
    const sort = datasetConfigSort && datasetConfigSort.length > 0
        ? datasetConfigSort
        : getSortFromSchema(await getSchema());
    return sort.length > 0 ? sort : null;
};
//# sourceMappingURL=getSort.js.map